import React from 'react'
import { getFileName } from '../../helper/getFileName'
import { formatDate } from '../../helper/formatDate'
import { aedLogoStyle, getDirhamImage } from '../../common/cssclasses'
import PillBtn from '../PillBtn'

export default function AuctionEntryItem({ item, i, translate, currentLanguage }) {

    return (
        <div
            className="col-lg-6 col-md-12 col-sm-12 mb-main"
            key={i}
        >
            <div className="p-main bg-white border-15 p-3 h-100">
                <div className='row rtl mb-form-group'>
                    <div className="col-lg-4 col-md-8 col-sm-12">
                        <img
                            className='w-100'
                            src={item?.attachment}
                            alt={getFileName(item?.attachment)}
                            onError={(e) => e.currentTarget.classList.add('d-none')}
                        />
                    </div>

                    <div className="col-lg-8 col-md-8 col-sm-12  ">
                        <div className="col-md-12 col-sm-12 ">
                            <div className="showNewTitle">
                                {item?.nameEn}
                            </div>
                        </div>
                        <div class="showNewDetials">
                            {item?.startDate && <div class="showNewRank showNewStartDate ">
                                <div>
                                    <i class="fa fa-calendar red" ></i>{translate(
                                        "web.startDate",
                                        "Start Date"
                                    )}:
                                </div>
                                <div>{formatDate(item.startDate)}</div>
                            </div>}
                            {item?.endDate &&
                                <div class="showNewLocation showNewStartDate">
                                    <div>
                                        <i class="fa fa-calendar red" ></i>
                                        {translate("web.endDate", "End Date")}:
                                    </div>
                                    <div>
                                        {formatDate(item.endDate)}
                                    </div>
                                </div>
                            }
                            {item?.participationStartDate &&
                                <div class="showNewLocation showNewStartDate">
                                    <div>
                                        <i class="fa fa-calendar red" ></i>
                                        {translate(
                                            "web.registerStartDate",
                                            "Register Start Date"
                                        )}:
                                    </div>
                                    <div>
                                        {formatDate(item?.participationStartDate)}
                                    </div>
                                </div>
                            }
                            {item?.participationEndDate &&
                                <div class="showNewLocation showNewStartDate">
                                    <div>
                                        <i class="fa fa-calendar red" ></i>
                                        {translate(
                                            "web.registerEndDate",
                                            "Register End Date"
                                        )}:
                                    </div>
                                    <div>
                                        {formatDate(item?.participationEndDate)}
                                    </div>
                                </div>
                            }
                            <div class="showNewLocation showNewStartDate">
                                <div>
                                    <img src={getDirhamImage(currentLanguage)} alt='AED' style={aedLogoStyle} />
                                    {translate(
                                        "web.fees",
                                        "Fees"
                                    )}
                                    :
                                </div>
                                <div className='fw-bold'>
                                    {item?.horseFees} {translate('web.aed', 'AED')}
                                </div>
                            </div>
                            <div class="showNewStartDate showNewLocation mb-form-group">
                                <div>
                                    <i class="fa-solid fa-chess-knight red" ></i>
                                    {translate(
                                        "web.maxNoPerOwner",
                                        "Max no of horses to register per owner"
                                    )}
                                    :
                                </div>
                                <div className='fw-bold'>
                                    {item.maxNumberPerOwner > 0
                                        ? item.maxNumberPerOwner
                                        : translate(
                                            "web.unlimited",
                                            "Unlimited"
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row  ">
                    <div className="col-md-6 col-sm-12 text-start  ms-auto">
                        <PillBtn
                            isNoMargin
                            routeName={
                                `/auctionParticipate?auctionId=${item.id}`}
                            text={translate("web.participateNow", "Participate Now")
                            }
                            isRed={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
